'use strict';

const _ = require('lodash');
const dead = (episodeOfCare) => {
    return (
        _.get(
            (episodeOfCare.extension || []).find(
                (e) =>
                    e.url ===
                    'http://narushealth.com/fhir/episodeofcare-caseClosureReason'
            ),
            'valueString'
        ) === 'expired'
    );
};

module.exports = {
    dead
};
